// extracted by mini-css-extract-plugin
export default {"breadcumb":"Breadcumb_breadcumb__T+dBn","breadcumb_list":"Breadcumb_breadcumb_list__b57Bw"};